import axios from "axios";
import { GetHallServerUrl } from "@/data/urls";

const PUBLIC_IP_URL = "https://api.ipify.org";
let publicIPRequestId = 0;

export const SendCMD = async (cmd, msg, version) => {
  let result = await axios({
    method: "post",
    url: GetHallServerUrl(),
    data: JSON.stringify({
      cmd,
      msg,
      ...(version === undefined ? {} : { version }),
    }),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  });
  return result.data;
};

export const GetPublicIP = () => {
  if (typeof window == "undefined" || typeof document == "undefined") {
    return Promise.reject(new Error("Public IP lookup is only available in the browser"));
  }

  return new Promise((resolve, reject) => {
    const callbackName = `__getPublicIP${Date.now()}_${publicIPRequestId++}`;
    const script = document.createElement("script");
    let settled = false;
    let timeoutId = null;

    const complete = (error, ip) => {
      if (settled) {
        return;
      }
      settled = true;
      window.clearTimeout(timeoutId);
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      delete window[callbackName];
      if (error) {
        reject(error);
      } else {
        resolve(ip);
      }
    };

    window[callbackName] = (data) => {
      const ip = data && typeof data.ip == "string" ? data.ip.trim() : "";
      complete(ip ? null : new Error("Public IP lookup returned no IP address"), ip);
    };
    script.onerror = () => complete(new Error("Failed to get public IP address"));
    script.src = `${PUBLIC_IP_URL}?format=jsonp&callback=${callbackName}`;
    timeoutId = window.setTimeout(() => complete(new Error("Public IP lookup timed out")), 5000);
    document.head.appendChild(script);
  });
};
